<ng-container *ngIf="success">
  <div class="row">
    <div class="col-12 col-lg-6 offset-lg-3">
      <div class="card-body">
        <div class="alert alert-success p-2 font-sm rounded-0">
          Your password has been successfully updated.
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!success">
  <div class="row">
    <div class="col-12 col-lg-6 offset-lg-3">

      <form #thisForm="ngForm">

        <div class="form-group">
          <label class="control-label" for="txt_Password">New password</label>
          <input type="password" id="txt_Password" name="txt_Password" class="form-control form-control-lg input-blue-border" [(ngModel)]="request.Password" pattern="^.{13,50}$" required>
          <span class="error-label">Password is required and must be a minimum length of 13 alphanumeric characters</span>
        </div>

        <div class="form-group">
          <label class="control-label" for="txt_ConfirmPassword">Confirm password</label>
          <input type="password" id="txt_ConfirmPassword" name="txt_ConfirmPassword" class="form-control form-control-lg input-blue-border" [(ngModel)]="request.ConfirmPassword" [pattern]="'^'+this.request.Password+'$'" required>
          <span class="error-label">Confirm password must match password</span>
        </div>

      </form>

    </div>
  </div>

  <div class="row">
    <div class="col-12 col-lg-6 offset-lg-3">
      <button type="button" class="btn btn-primary" (click)="Save(thisForm,$event)" *ngIf="!processing">Reset Password</button>
      <span class="btn btn-dark" *ngIf="processing"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
    </div>
  </div>
</ng-container>
